export enum enumFundingSourceType {
  CORE = 1,
  SUPP = 2
}
